import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";

const Main = lazy(() => import("../../components/transactions/transactionHistory/main"));

const TransactionHistory = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default TransactionHistory;

